import {
    FormRequest,
    BankFormRequest,
    CommentRequest,
} from "@herbjoy/apex-api-models";

import { IHttpService, IQService } from 'angular';
import { UtilityService } from '../utility.service';

export class OnboardingDocumentService {
    constructor(private $http: IHttpService, private $q: IQService, private apexApiUrl: string, private utilityService: UtilityService) {
        'ngInject';
    }

    resolvePromise(formPromises, returnPromise) {
        // Check if formPromises is not an array or is an empty array
        if (!Array.isArray(formPromises) || formPromises.length === 0) {
            console.log('No form promises to resolve.');
            return this.utilityService.showLoadingUntilResolved(returnPromise());
        }
        /*this.arePromisesResolved(formPromises);*/
        //if (returnPromise && typeof returnPromise.then === 'function' && returnPromise.$$state.status === 1) {
        //    // Promise is resolved
        //    console.log('Promise already resolved:', returnPromise);
        //} else {
        //    // Promise is not resolved
        //    console.log('Promise not resolved:', returnPromise);
        //    // Return false if any promise is not resolved
        //}

        //this.utilityService.showLoading();
        const trans = this.$q.all(formPromises)
            .then((res) => {
                if (res) {
                    returnPromise();
                }
            }).catch((err) => {
                return this.$q.reject(err);
            });
        //.finally(() => {
        //    this.utilityService.hideLoading();  // Hide loading irrespective of the result
        //});

        this.utilityService.showLoadingUntilResolved(
            this.utilityService.alertOnError(trans, "Save failed")
        );
    }

    arePromisesResolved(formPromises) {
        for (let promise of formPromises) {
            // Check if the promise is resolved
            if (promise && typeof promise.then === 'function' && promise.$$state.status === 1) {
                // Promise is resolved
                console.log('Promise already resolved:', promise);
            } else {
                // Promise is not resolved
                console.log('Promise not resolved:', promise);
                // Return false if any promise is not resolved
            }
        }
        return true; // All promises are resolved
    }

    testPromise(returnPromise) {
        var promises = [];
        for (var i = 1; i <= 3; i++) {
            var promise = this.$q(function (resolve, reject) {
                // Simulate an asynchronous operation (e.g., fetching data)
                setTimeout(function () {
                    var randomNumber = Math.random();
                    if (randomNumber > 0.5) {
                        resolve('Promise ' + i + ' resolved'); // Resolve the promise
                    } else {
                        reject('Promise ' + i + ' rejected'); // Reject the promise
                    }
                }, Math.random() * 2000); // Random delay between 0 and 2 seconds
            });

            promises.push(promise);
        }
        console.log(promises);

        this.utilityService.showLoadingUntilResolved(this.$q.all(promises).then(function (results) {
            console.log('All promises resolved:', results);
        }).catch(function (error) {
            console.error('Error:', error);
        }));
    }
    //resolvePromise(formPromises: any, returnPromise: any) {
    //    return this.utilityService.showLoadingUntilResolved(
    //        this.utilityService.alertOnError(this.$q.all([formPromises]), "Initial load failed"))
    //        .then(() => {
    //            return this.$q.when([returnPromise, this.utilityService.hideLoading()]);
    //        });
    //}

    updateBankInfo(employeeID: string, employeeBankInfo: any) { // change any to UpdateOnboardingEmployeeBankInfoRequest
        return this.$http({
            method: "PUT",
            url: this.apexApiUrl + "OnboardingDocument/bankinfo/" + employeeID,
            headers: { "Content-Type": "application/json" },
            data: JSON.stringify(employeeBankInfo)
        }).then(function (response) {
            return response.data;
        });
    }


    private getTaxFormFileName(requestTypeId: string): string {
        const map: { [key: string]: string } = {
            '1': 'Instructions',
            '2': 'StateW4',
            '-2': 'W9',
            '5': 'FederalW4',
            '3': 'I9'
        };
        const key = (requestTypeId || '').toUpperCase();
        const prefix = map[key] ?? 'TaxForm';
        return prefix;
    }

    getTaxForm(employeeId: string, requestTypeId: string) {
        return this.$http({
            method: "GET",
            responseType: 'blob',
            url: this.apexApiUrl + "OnboardingDocument/GetTaxForm/" + employeeId + "/" + requestTypeId,
            headers: { Accept: "application/json" }
        }).then(result => {

            const headers = result.headers ? result.headers() : {};
            let fileName: string | null = null;
            const disposition = headers['content-disposition'] || headers['Content-Disposition'];
            if (disposition) {
                const match =
                    /filename\*?=(?:UTF-8''|")?([^;"\n]+)/i.exec(disposition);
                if (match?.[1]) {
                    fileName = decodeURIComponent(match[1].replace(/"/g, ''));
                }
            }
            // 2?? Fallback filename (never breaks)
            if (!fileName) {
                fileName = `${this.getTaxFormFileName(requestTypeId)}_${employeeId}.pdf`;
            }
            const blob = new Blob(
                [result.data as BlobPart],
                { type: headers['content-type'] || 'application/pdf' }
            );

            const objectUrl: string = URL.createObjectURL(blob);
            const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
            a.href = objectUrl;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();

            document.body.removeChild(a);
            URL.revokeObjectURL(objectUrl);
        });

    }


    downloadTemplate(requestTypeId: string, stateID: string) {
        return this.$http({
            method: "POST",
            responseType: 'blob',
            url: this.apexApiUrl + "OnboardingDocument/DownloadTemplate/" + requestTypeId + "/" + stateID,
            data: { userName: 'akasina@thesmartcircle.com' },
            headers: { Accept: "application/json" }
        }).then(result => {

            const headers = result.headers ? result.headers() : {};
            let fileName: string | null = null;
            const disposition = headers['content-disposition'] || headers['Content-Disposition'];
            if (disposition) {
                const match =
                    /filename\*?=(?:UTF-8''|")?([^;"\n]+)/i.exec(disposition);
                if (match?.[1]) {
                    fileName = decodeURIComponent(match[1].replace(/"/g, ''));
                }
            }
            // 2?? Fallback filename (never breaks)
            if (!fileName) {
                fileName = `${this.getTaxFormFileName(requestTypeId)}_${requestTypeId}.pdf`;
            }
            const blob = new Blob(
                [result.data as BlobPart],
                { type: headers['content-type'] || 'application/pdf' }
            );

            const objectUrl: string = URL.createObjectURL(blob);
            const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
            a.href = objectUrl;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();

            document.body.removeChild(a);
            URL.revokeObjectURL(objectUrl);
        });

    }

    updateTaxState(employeeId: string, stateToBeTaxedIn: string) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "OnboardingDocument/UpdateTaxState/" + employeeId + "/" + stateToBeTaxedIn,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });

    }

    retrieveChangeFormMapping() {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "OnboardingDocument/GetChangeFormMapping",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }


    updateFormChange(applicationID, data, isOwner, missingOnboardingInfo = false) {
        //const dt = {
        //    applicationID: applicationID,
        //    changes: data
        //};
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "OnboardingDocument/UpdateChangeFormMapping/" + applicationID + "/" + isOwner + "?missingOnboardingInfo=" + !!missingOnboardingInfo,
            data: JSON.stringify(data),
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    reterieveApplication(employeeId: string) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "OnboardingDocument/reterieveApplication/" + employeeId,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    retrieveApplicationById(applicationId: string) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "OnboardingDocument/retrieveApplicationById/" + applicationId,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    changeApplicationToPaper(applicationNumber: string) {
        return this.$http({
            method: "Post",
            url: this.apexApiUrl + "OnboardingDocument/ChangeApplicationToPaper?applicationNumber=" + applicationNumber,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            // settaxNoticeReferences(response.data);
            return response.data;
        }).catch((err) => {
            this.utilityService.hideLoading();
            alert("Change to paper application failed: " + this.utilityService.getExceptionMessage(err));
        });
    }

    changeApplicationToOnline(applicationNumber: string) {
        return this.$http({
            method: "Post",
            url: this.apexApiUrl + "OnboardingDocument/ChangeApplicationToOnline?applicationNumber=" + applicationNumber,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            // settaxNoticeReferences(response.data);
            return response.data;
        }).catch((err) => {
            this.utilityService.hideLoading();
            alert("Change to paper application failed: " + this.utilityService.getExceptionMessage(err));
        });
    }

    retrieveApplication(userName: string) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "OnboardingDocument/GetApplication?userName=" + encodeURIComponent(userName),
            headers: { Accept: "application/json" }
        }).then(function (response) {
            // settaxNoticeReferences(response.data);
            return response.data;
        }).catch((err) => {
            this.utilityService.hideLoading();
            alert("Retrieving failed: " + this.utilityService.getExceptionMessage(err));
        });
    }

    /**
     * Get the list of all applications matching the given query, along
     * with paging information according to the given requested index and size.
     * @param {number} pageIndex The 0-indexed page number to request
     * @param {any} query The query object describing the data that should be returned
     * @returns {Promise<any>} A page of application results.
     */
    retrieveApplicationPage(pageIndex: number, query) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "OnboardingDocument/page/" + (pageIndex || 0),
            params: query || {},
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        }).catch((err) => {
            this.utilityService.hideLoading();
            alert("Retrieving failed: " + this.utilityService.getExceptionMessage(err));
        });
    }

    retrieveTemplate(userName: string, requestTypeId: string, stateId: string, pages?: string) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "OnboardingDocument/DownloadTemplate/" + requestTypeId + "/" + stateId + "?userName=" + encodeURIComponent(userName) + (pages ? "&pages=" + encodeURIComponent(pages) : ""),
            responseType: 'arraybuffer',
            headers: { "Content-Type": "application/json" }
        }).then((result) => {
            const headers = result.headers ? result.headers() : {};
            let fileName: string | null = null;
            const disposition = headers['content-disposition'] || headers['Content-Disposition'];
            if (disposition) {
                const match =
                    /filename\*?=(?:UTF-8''|")?([^;"\n]+)/i.exec(disposition);
                if (match?.[1]) {
                    fileName = decodeURIComponent(match[1].replace(/"/g, ''));
                }
            }
            // 2?? Fallback filename (never breaks)
            if (!fileName) {
                fileName = `${this.getTaxFormFileName(requestTypeId)}.pdf`;
            }
            const blob = new Blob(
                [result.data as BlobPart],
                { type: headers['content-type'] || 'application/pdf' }
            );

            const objectUrl: string = URL.createObjectURL(blob);
            const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
            a.href = objectUrl;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();

            document.body.removeChild(a);
            URL.revokeObjectURL(objectUrl);
        });


    }

    getUserRole(userName: string) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "OnboardingDocument/GetUserRole?userName=" + encodeURIComponent(userName),
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    retrieveApplicationForOwner(userName: string) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "OnboardingDocument/GetApplicationForOwner?userName=" + encodeURIComponent(userName),
            headers: { Accept: "application/json" }
        }).then(function (response) {
            // settaxNoticeReferences(response.data);
            return response.data;
        });

    }

    retrieveComments(applicationId: string) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "OnboardingDocument/GetComments/" + applicationId,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            // settaxNoticeReferences(response.data);
            return response.data;
        });
    }

    saveComment(data: CommentRequest) {
        console.log(data);
        const formData = this.createRequestFormDataComment(data);
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + 'OnboardingDocument/saveComment',
            data: formData,
            headers: { "Content-Type": undefined, Accept: "application/json" }
        })
            .then(function (response) {
                // settaxNoticeReferences(response.data);
                return response.data;
            })

    }

    //saveReviewComment(data: ReviewCommentRequest) {
    //    console.log(data);
    //    const formData = this.createRequestFormDataReviewComment(data);
    //    return this.$http({
    //        method: "POST",
    //        url: this.apexApiUrl + 'OnboardingDocument/saveComment',
    //        data: formData,
    //        headers: { "Content-Type": undefined, Accept: "application/json" }
    //    })
    //        .then(function (response) {
    //            // settaxNoticeReferences(response.data);
    //            return response.data;
    //        })

    //}

    private createRequestFormDataComment(request: any): FormData {
        const formData = new FormData();
        formData.append("ApplicationId", request.ApplicationId);
        formData.append("UserName", request.UserName);
        formData.append("Text", request.Text);
        return formData;
    }

    private createRequestFormDataReviewComment(request: any): FormData {
        const formData = new FormData();
        formData.append("ApplicationId", request.ApplicationId);
        formData.append("UserName", request.UserName);
        formData.append("Text", request.Text);
        formData.append("FedW4Error", request.FedW4Error);
        formData.append("ProvW4Error", request.ProvW4Error);
        formData.append("I9Error", request.I9Error);
        formData.append("DDerror", request.DDerror);
        return formData;
    }

    approveApplication(employeeId: any) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "OnboardingDocument/ApproveApplication/" + employeeId,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            // settaxNoticeReferences(response.data);
            return response.data;
        });
    }

    approveOnboardingForm(applicationId: string, requestTypeId: string) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "OnboardingDocument/ApproveOnboardingForm/" + applicationId + "/" + requestTypeId,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            // settaxNoticeReferences(response.data);
            return response.data;
        });
    }

    removeApplication(applicationId: string) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "OnboardingDocument/RemoveApplication/" + applicationId,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            // settaxNoticeReferences(response.data);
            return response.data;
        });
    }

    getSavedBankInfo(employeeId) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "OnboardingDocument/getSavedBankInfo/" + employeeId,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            // settaxNoticeReferences(response.data);
            return response.data;
        });

    }

    getBankInfo(employeeId) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "OnboardingDocument/getBankInfo/" + employeeId,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            // settaxNoticeReferences(response.data);
            return response.data;
        });

    }

    getBankAccountTypes() {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "OnboardingDocument/getBankAccountTypes",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            // settaxNoticeReferences(response.data);
            return response.data;
        });

    }

    getBankDepositTypes() {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "OnboardingDocument/getBankDepositTypes",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            // settaxNoticeReferences(response.data);
            return response.data;
        });

    }

    retrieveUserInput(employeeId, requestTypeId, stateId) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "OnboardingDocument/retrieveUserInput/" + employeeId + "/" + requestTypeId + "/" + stateId,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });

    }

    retrieveSavedInput(employeeId, requestTypeId, stateId) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "OnboardingDocument/retrieveUserInput/" + employeeId + "/" + requestTypeId + "/" + stateId + "/true",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });

    }

    retrieveAddlInputs(employeeID) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "OnboardingDocument/RetrieveAddlFields/" + employeeID,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });

    }

    setAddlInput(employeeID, fieldName, value) {
        var requestData = {
            EmployeeID: employeeID,
            FieldName: fieldName,
            Value: value
        };

        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "OnboardingDocument/SetAddlField",
            data: JSON.stringify(requestData),
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });

    }

    submitApplication(employeeId) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "OnboardingDocument/SubmitApplication/" + employeeId,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    createApplication(employeeId, stateToBeTaxedIn) {
        return this.$http({
            method: "Post",
            url: this.apexApiUrl + "OnboardingDocument/CreateApplication/" + employeeId + "/" + stateToBeTaxedIn,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    startApplication(employeeId) {
        return this.$http({
            method: "Post",
            url: this.apexApiUrl + "OnboardingDocument/StartApplication/" + employeeId,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    saveBankAccount(data: BankFormRequest) {
        const formData = this.createBankAccountFormData(data);
        console.log(formData);
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "OnboardingDocument/SaveBankAccount",
            data: formData,
            headers: { "Content-Type": undefined }
        }).then(function (response) {
            return response.data;
        });

    }

    clearSavedBankAccount(employeeID) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "OnboardingDocument/ClearSavedBankAccount/" + employeeID,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });

    }

    submitBankAccount(data: BankFormRequest) {
        const formData = this.createBankAccountFormData(data);
        console.log(formData);
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "OnboardingDocument/SubmitBankAccount",
            data: formData,
            headers: { "Content-Type": undefined }
        }).then(function (response) {
            return response.data;
        });

    }

    removeBankAccount(data) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "OnboardingDocument/RemoveBankAccount/" + data,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });

    }

    getRequestTypes() {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "OnboardingDocument/GetRequestTypes",
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            });

    }

    private createBankAccountFormData(request): FormData {
        const formData = new FormData();
        formData.append("BankAccountID", request.BankAccountID);
        formData.append("EmployeeNumber", request.EmployeeNumber);
        formData.append("BankName", request.BankName);
        formData.append("RoutingNumber", request.RoutingNumber);
        formData.append("AccountNumber", request.AccountNumber);
        formData.append("InstitutionNumber", request.InstitutionNumber);
        formData.append("BankAccountTypeID", request.BankAccountTypeID);
        formData.append("DepositAmountTypeID", request.DepositAmountTypeID);
        formData.append("DepositAmount", request.DepositAmount);
        return formData;
    }

    checkIfProvinceW4Required(stateProvinceID) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "OnboardingDocument/CheckIfProvinceW4Required/" + stateProvinceID,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    retrievefields(userName) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "OnboardingDocument/RetrieveFields?userName=" + encodeURIComponent(userName),
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });

    }

    save(userName, data: FormRequest, stateId: string) {
        //const formData = this.mapObjectToFormData(data);
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "OnboardingDocument/Save/" + stateId + "?userName=" + encodeURIComponent(userName),
            data: JSON.stringify(data),
            responseType: 'json',
            headers: { "Content-Type": "application/json", Accept: "application/json" }
        }).then(function (result) {
            return result.data;
        });

    }


    submit(userName, data: FormRequest, stateId: string) {
        //const formData = this.mapObjectToFormData(data);
        //const url = this.apexApiUrl + "OnboardingDocument/Submit/" + stateId + "?userName=" + encodeURIComponent(userName);
        //if (file) {
        //    const formData = new FormData();
        //    formData.append('file', file, file.name);
        //    // send FormRequest fields as individual form entries
        //    Object.keys(data).forEach(key => {
        //        if (data[key] != null) formData.append(key, data[key]);
        //    });
        //    return this.$http({
        //        method: "POST",
        //        url: url,
        //        data: formData,
        //        headers: { "Content-Type": undefined }   
        //    }).then(result => result.data);
        //} else {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "OnboardingDocument/Submit/" + stateId + "?userName=" + encodeURIComponent(userName),
            data: JSON.stringify(data),
            responseType: 'json',
            headers: { "Content-Type": "application/json", Accept: "application/json" }
        }).then(function (result) {
            return result.data;
        });
        //}

    }



    preview(userName, data: FormRequest, stateId: string) {
        //const formData = this.mapObjectToFormData(data);
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "OnboardingDocument/Preview/" + stateId + "?userName=" + encodeURIComponent(userName),
            data: JSON.stringify(data),
            responseType: 'arraybuffer',
            headers: { "Content-Type": "application/json" }
        }).then((result) => {
            const headers = result.headers ? result.headers() : {};
            let fileName: string | null = null;
            const disposition = headers['content-disposition'] || headers['Content-Disposition'];
            if (disposition) {
                const match =
                    /filename\*?=(?:UTF-8''|")?([^;"\n]+)/i.exec(disposition);
                if (match?.[1]) {
                    fileName = decodeURIComponent(match[1].replace(/"/g, ''));
                }
            }
            // 2?? Fallback filename (never breaks)
            if (!fileName) {
                fileName = `${userName}_${stateId}.pdf`;
            }
            let filesBytes: any = result.data;

            const blob = new Blob([filesBytes], { type: result.headers("Content-Type") });
            const objectUrl: string = URL.createObjectURL(blob);
            const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
            a.href = objectUrl;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();

            document.body.removeChild(a);
            URL.revokeObjectURL(objectUrl);
        });

    }

    previewUrl(userName, data: FormRequest, stateId: string) {
        //const formData = this.mapObjectToFormData(data);
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "OnboardingDocument/Preview/" + stateId + "?userName=" + encodeURIComponent(userName),
            data: JSON.stringify(data),
            responseType: 'arraybuffer',
            headers: { "Content-Type": "application/json" }
        }).then((result) => {
            let filesBytes: any = result.data;
            //let fileName = result.headers('Content-Disposition').split(';')[1].trim().split('filename=')[1].replace(/"/g, '');
            const blob = new Blob([filesBytes], { type: result.headers("Content-Type") });
            const objectUrl: string = URL.createObjectURL(blob);
            return objectUrl;
        });

    }

    previewDocument(employeeID, data: FormRequest) {
        //const formData = this.mapObjectToFormData(data);
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "OnboardingDocument/PreviewDocument/" + employeeID,
            data: JSON.stringify(data),
            responseType: 'arraybuffer',
            headers: { "Content-Type": "application/json" }
        }).then((result) => {
            let filesBytes: any = result.data;
            //let fileName = result.headers('Content-Disposition').split(';')[1].trim().split('filename=')[1].replace(/"/g, '');
            const blob = new Blob([filesBytes], { type: result.headers("Content-Type") });
            const objectUrl: string = URL.createObjectURL(blob);
            return objectUrl;
        });

    }

    setReviewRequired(employeeId: string, requestTypeId: string) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "OnboardingDocument/SetReviewRequired/" + employeeId + "/" + requestTypeId,
            responseType: 'json',
            headers: { "Content-Type": undefined, Accept: "application/json" }
        }).then(function (result) {
            return result.data;
        });
    }

    // APEX-978 - owner pushes a group of forms back to the employee for review + a comment.
    // Backend sets the forms to ReviewRequired (status -> Review) and sends email/SMS to the employee.
    requestReview(employeeId, formIds, comment, option) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "OnboardingDocument/RequestReview/" + employeeId,
            data: { FormIds: formIds, Comment: comment, Option: option },
            headers: { "Content-Type": "application/json", Accept: "application/json" }
        }).then(function (result) {
            return result.data;
        });
    }

    // Marks ProvinceW4 as Submitted for an IL exempt/nonresident opt-out (no filled PDF/signature). APEX-321.
    markProvinceW4Exempt(employeeId: string) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "OnboardingDocument/MarkProvinceW4Exempt/" + employeeId,
            responseType: 'json',
            headers: { "Content-Type": undefined, Accept: "application/json" }
        }).then(function (result) {
            return result.data;
        });
    }

    private mapObjectToFormData(obj): FormData {
        const formData = new FormData();
        for (const prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                formData.append(prop, obj[prop]);
            }
        }
        return formData;
    }

}
